import 'inventory-listing/components/OrderBy/OrderBy.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initial, last, values, map, isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputDropDown } from '@sm360/widget-commons-forms';
import {
    SessionStorageService,
    AnalyticsService,
    TRACKING_TAGS as TAGS,
    ADOBE_TAGS,
    AdobeService,
    ADOBE_VARIANT_CONSTANTS,
} from '@sm360/widget-commons-general';
import { InventoryTypeConstants } from '@sm360/widget-commons-vehicle';

import * as Actions from 'inventory-listing/actions/listingUsedActions.js';
import SORTINGS from 'inventory-listing/constants/sortings';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

class ListingPaymentOrderBy extends React.Component {
    constructor(props) {
        super(props);

        let searchSort = map(values(SORTINGS), (sort) => ({
            ...sort,
            label: LocaleService.t(sort.transKey),
        }));
        if (!props.allowSortByDefault) {
            searchSort = searchSort.filter((sort) => sort.value !== SORTINGS.DEFAULT.value);
        }

        this.state = {
            searchSort,
        };
        this.sortChange = this.sortChange.bind(this);
    }

    sortChange(option) {
        AnalyticsService.ga4Trigger(TAGS.INVENTORY_LISTING(option.label));
        SessionStorageService.set('vehicleSorting', JSON.stringify(option.value));

        if (this.props.hasAdobeTagging) {
            if (this.props.colanderGroupSlug === COLANDER_GROUPS.COMMERCIAL) {
                // This is used commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_SORT_BY(InventoryTypeConstants.USED, option.label),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else if (
                this.props.colanderGroupSlug === COLANDER_GROUPS.NEW &&
                this.props.inventoryType === InventoryTypeConstants.COMMERCIAL
            ) {
                // This is new commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_SORT_BY(InventoryTypeConstants.NEW, option.label),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else {
                // This is either new or used inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.SEARCH_RESULT_PAGE_SORT_BY(
                        this.props.colanderGroupSlug === COLANDER_GROUPS.NEW ? 'New' : 'Used',
                        option.label
                    ),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            }
        }
        if (option.value === SORTINGS.DEFAULT.value) {
            this.props.actions.resetVehicleSortingToDefault();
        } else {
            const splitOptions = option.value.split('_');

            this.props.actions.updateVehicleSorting(initial(splitOptions).join('_'), last(splitOptions));
        }
    }

    render() {
        const defaultValue = !this.props.allowSortByDefault ? SORTINGS.SALE_PRICE_ASC.value : 'DEFAULT';
        return (
            <div className="sort order-by-component">
                <InputDropDown
                    name="purchaseMethodSort"
                    value={
                        isEmpty(this.props.vehicleOrders)
                            ? defaultValue
                            : `${this.props.vehicleOrders.vehicleSortParameter}_${this.props.vehicleOrders.direction}`
                    }
                    options={this.state.searchSort}
                    placeholder={LocaleService.t('SORT_BY')}
                    valueChange={this.sortChange}
                    classNames={['input-dropdown']}
                />
            </div>
        );
    }
}

ListingPaymentOrderBy.defaultProps = {
    allowSortByDefault: false,
    vehicleOrders: {},
    inventoryType: '',
    hasAdobeTagging: false,
    colanderGroupSlug: '',
};
ListingPaymentOrderBy.propTypes = {
    actions: PropTypes.shape({
        updateVehicleCriteria: PropTypes.func.isRequired,
        updateVehicleSorting: PropTypes.func.isRequired,
        resetVehicleSortingToDefault: PropTypes.func.isRequired,
    }),
    allowSortByDefault: PropTypes.bool,
    vehicleOrders: PropTypes.object.isRequired,
    inventoryType: PropTypes.string.isRequired,
    hasAdobeTagging: PropTypes.bool,
    colanderGroupSlug: PropTypes.string.isRequired,
};

ListingPaymentOrderBy.displayName = 'ListingPaymentOrderBy';

function mapStateToProps({ listingUsed }) {
    const { vehicleOrders } = listingUsed;

    return {
        vehicleOrders,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { ListingPaymentOrderBy };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListingPaymentOrderBy);
